import React from "react";
export const HelpCircle = () => (
  <svg viewBox="0 0 14 16">
    <path d="M7 1.33C3.32 1.33.33 4.32.33 8S3.32 14.67 7 14.67s6.67-2.99 6.67-6.67S10.68 1.33 7 1.33zm.67 11.34H6.33v-1.33h1.33v1.33zM9.05 7.5l-.6.61c-.34.34-.58.65-.7 1.13-.05.21-.08.45-.08.76H6.33v-.33c0-.31.05-.6.15-.87.13-.39.35-.73.63-1.01l.83-.84c.31-.29.45-.73.37-1.2-.09-.49-.46-.9-.93-1.03-.74-.21-1.43.21-1.65.85-.08.24-.28.43-.54.43h-.2c-.39 0-.66-.37-.55-.75a2.68 2.68 0 012.15-1.89c1.01-.16 1.98.37 2.58 1.2.79 1.09.56 2.26-.12 2.94z" />
  </svg>
);
